import { QUESTION_REVIEW_TASK_DATA_TEST_ID } from '@e2e/constants/exam-management';
import { Box, Button, PersonAddAltOutlinedIcon, Tooltip } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { MAX_SUBTASK_COUNT } from '../../constants';
import { useQuestionReviewTaskDetails } from '../../providers';
import { AddReviewerModal } from '../add-reviewer-modal';

export default function AddReviewerButton() {
  const {
    taskDetails: { subtasks },
    checkUserAbility,
  } = useQuestionReviewTaskDetails();

  const isReachMaxSubtask = subtasks.length >= MAX_SUBTASK_COUNT;

  const [isAddReviewerModalOpen, { open: openAddReviewerModal, close: closeAddReviewerModal }] =
    useDisclosure();

  const hasAccessToAddAssignee = checkUserAbility('ADD_SUBTASK');

  if (!hasAccessToAddAssignee) {
    return null;
  }

  return (
    <>
      <Tooltip
        title='เพิ่มผู้ทบทวนได้สูงสุด 3 คน'
        arrow
        placement='top'
        disableHoverListener={!isReachMaxSubtask}
      >
        <Box component='span' sx={{ maxWidth: 'fit-content' }}>
          <Button
            data-testid={QUESTION_REVIEW_TASK_DATA_TEST_ID.ADD_REVIEWER_BUTTON}
            color='primary'
            startIcon={<PersonAddAltOutlinedIcon />}
            disabled={isReachMaxSubtask}
            onClick={openAddReviewerModal}
          >
            Add Reviewer
          </Button>
        </Box>
      </Tooltip>
      <AddReviewerModal open={isAddReviewerModalOpen} onClose={closeAddReviewerModal} />
    </>
  );
}
